export const COMMON_RESPONSE_HEADER_KEYS = {
    CSRF_IDENTIFIER: 'csrfidentifier',
};
